import { jsx } from "react/jsx-runtime";
import { useEditor } from "@tldraw/editor";
import { useCallback, useRef } from "react";
import { useUiEvents } from "../../context/events.mjs";
import { TldrawUiInput } from "../primitives/TldrawUiInput.mjs";
const PageItemInput = function PageItemInput2({
  name,
  id,
  isCurrentPage,
  onCancel,
  onComplete
}) {
  const editor = useEditor();
  const trackEvent = useUiEvents();
  const rMark = useRef(null);
  const handleFocus = useCallback(() => {
    rMark.current = editor.markHistoryStoppingPoint("rename page");
  }, [editor]);
  const handleChange = useCallback(
    (value) => {
      editor.renamePage(id, value || "New Page");
      trackEvent("rename-page", { source: "page-menu" });
    },
    [editor, id, trackEvent]
  );
  const handleCancel = useCallback(() => {
    if (rMark.current) {
      editor.bailToMark(rMark.current);
    }
    onCancel();
  }, [editor, onCancel]);
  void isCurrentPage;
  const handleBlur = useCallback(() => {
    onComplete?.();
  }, [onComplete]);
  return /* @__PURE__ */ jsx(
    TldrawUiInput,
    {
      className: "tlui-page-menu__item__input",
      defaultValue: name,
      onValueChange: handleChange,
      onComplete,
      onCancel: handleCancel,
      onFocus: handleFocus,
      onBlur: handleBlur,
      shouldManuallyMaintainScrollPositionWhenFocused: true,
      autoFocus: true,
      autoSelect: true
    }
  );
};
export {
  PageItemInput
};
//# sourceMappingURL=PageItemInput.mjs.map
